const extractPrice = (priceElement) => {
  const childValueNode = priceElement.childNodes[1];
  if (!childValueNode) {
    return '';
  }

  const optionPriceContent = childValueNode.textContent;
  return optionPriceContent ? optionPriceContent.match(/\((.*)\)/)[1] : '';
};

const changePrice = (priceElement, { convertedPrice }) => {
  priceElement.childNodes[1].textContent = ` (${convertedPrice})`;
};

const matchType = (selector) => selector.tagName === 'OPTION';

export default { matchType, extractPrice, changePrice, name: 'option' };
